import { gql } from "apollo-boost";

export const GET_ROLES = gql`
query Data($where: RoleWhereInput, $skip: Int, $limit: Int) {
    rolePermissions(where: $where, skip: $skip, limit: $limit) {
      total
      data {
        id
        name
        note
        permissions
        shop {
         id
         name 
        }
        isDeleted
        createdAt
        updatedAt
        message
      }
    }
  }
`;


export const GET_ROLE_PERMISSIONS = gql`
query User($where: UserWhereInputOne!) {
  user(where: $where) {
    firstName
    lastName
    permission {
      id
      name
      permissions
    }
  }
}
`
